/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_budget_unlock_tier_a_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See which top drivers and constructors are most likely to change price.`)
};

const es_f1_budget_unlock_tier_a_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mira qué pilotos y constructores top tienen más probabilidad de cambiar de precio.`)
};

const de_f1_budget_unlock_tier_a_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sieh, welche Top-Fahrer und -Konstrukteure am wahrscheinlichsten ihren Preis ändern.`)
};

const nl_f1_budget_unlock_tier_a_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk welke topcoureurs en -constructeurs het meest waarschijnlijk van prijs veranderen.`)
};

const fr_f1_budget_unlock_tier_a_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voyez quels pilotes et constructeurs de haut niveau sont les plus susceptibles de changer de prix.`)
};

const it_f1_budget_unlock_tier_a_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri quali piloti e costruttori top hanno più probabilità di cambiare prezzo.`)
};

const pt_br2_f1_budget_unlock_tier_a_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veja quais pilotos e construtores de ponta têm maior probabilidade de mudar de preço.`)
};

const pt_f1_budget_unlock_tier_a_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veja quais pilotos e construtores de topo têm maior probabilidade de mudar de preço.`)
};

const ja_f1_budget_unlock_tier_a_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トップドライバーとコンストラクターの価格変動確率を確認。`)
};

const zh_f1_budget_unlock_tier_a_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看哪些顶级车手和车队最可能变动价格。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_budget_unlock_tier_a_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_budget_unlock_tier_a_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_budget_unlock_tier_a_desc", locale)
	if (locale === "en") return en_f1_budget_unlock_tier_a_desc(inputs)
	if (locale === "es") return es_f1_budget_unlock_tier_a_desc(inputs)
	if (locale === "de") return de_f1_budget_unlock_tier_a_desc(inputs)
	if (locale === "nl") return nl_f1_budget_unlock_tier_a_desc(inputs)
	if (locale === "fr") return fr_f1_budget_unlock_tier_a_desc(inputs)
	if (locale === "it") return it_f1_budget_unlock_tier_a_desc(inputs)
	if (locale === "pt-BR") return pt_br2_f1_budget_unlock_tier_a_desc(inputs)
	if (locale === "pt") return pt_f1_budget_unlock_tier_a_desc(inputs)
	if (locale === "ja") return ja_f1_budget_unlock_tier_a_desc(inputs)
	return zh_f1_budget_unlock_tier_a_desc(inputs)
};